import React, { useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import {
  Box,
  Button,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import { updateEstadoStockTejido, getOne2} from "../../services/stockTejido.services";
import { toast } from "react-toastify";
import LoadingSpinner from "../../loadingSpinner";

const TrasladoTejido = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    try {
      const response = await getOne2(values.serie);
      if(response.estado===0 && response.status_active ===1) {
        await updateEstadoStockTejido(values.serie);
      setRegistrationSuccess(true);
      resetForm();
      } else if(response.status_active===0) {
        toast.error(
                `🚨 Serie fuera de stock`,
                {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
              return null; // Si no hay respuesta válida, devolvemos null
      } else { 
        toast.error(
                `🚨 Ya existe un registro con esta serie`,
                {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
              return null; //
      }
    } catch (err) {
      console.error("Error al enviar datos al backend:", err);
      setError(
        err.response?.data?.message || err.message || "Error al actualizar"
      );
      setRegistrationError(true);
      setIsLoading(false);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };

  const handleCloseModalSuccess = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  return (
    <Box m="20px">
      <Header
        title="Stock Entrada"
        subtitle="Entrada a Stock de Rollos"
      />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModalSuccess} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        initialValues={{ serie: "" }}
        validationSchema={yup.object({
          serie: yup.string().required("La serie es requerida"),
        })}
        onSubmit={handleFormSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns={isNonMobile ? "repeat(4, minmax(0, 1fr))" : "repeat(1, 1fr)"}
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Número de Serie"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.serie}
                name="serie"
                error={touched.serie && Boolean(errors.serie)}
                helperText={touched.serie && errors.serie}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  border: "none",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#bac609" },
                }}
                variant="contained"
              >
                Registrar
              </Button>
            </Box>
            <ModalCharge isLoading={isLoading} />
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default TrasladoTejido;
